var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"am-input-file__input",attrs:{"type":"file"},on:{"change":_vm.fileChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }